import React, { InputHTMLAttributes } from "react";
import { Input, InputGroupContainer, Label, Validation } from "./style";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
    label: string;
    error?: string | boolean;
    as?: React.ComponentType | string;
}
export const InputGroup: React.FC<IProps> = props => {
    const { label, as, error, ...rest } = props;
    return (
        <InputGroupContainer>
            <Label>{label}</Label>
            <Input as={as} error={error} {...rest} />
            {error && <Validation>{error}</Validation>}
        </InputGroupContainer>
    );
};
